// Debounce utility for resize handler
let headerResizeTimer = null;

function stickyheaderLoadInit() {
  var windowScroll = window.scrollY;
  let scrollHeightValue = 0;
  var headerElement = document.querySelector('.main-header-top');
  let header = document.querySelector('header');
  if (header) {

    let stickyHeader = header.getAttribute('data-sticky-header');
    let stickyHeaderType = header.getAttribute('data-header-type');
    if (stickyHeader == 'true') {
      headerElement.classList.add('sticky-header-active');
    }
    if (stickyHeaderType == 'always') {
      document.querySelector('body').classList.add("sticky-header-always")
    }

    const headerMainEl = headerElement.querySelector('[data-header-main]');
    if (headerMainEl) {
      // BATCH ALL DOM READS FIRST (avoid forced reflows)
      const announcementEl = document.querySelector('.announcement-wrapper');
      const transparentEl = headerElement.querySelector('[transparent="true"]');
      const body = document.querySelector('body');
      const viewportWidth = window.innerWidth;

      const headerHeight = headerMainEl.getBoundingClientRect().height.toFixed(2);
      const annoucementHeight = announcementEl ? announcementEl.getBoundingClientRect().height.toFixed(2) : null;

      // BATCH ALL DOM WRITES AFTER
      body.style.setProperty('--headerheight', `${headerHeight}px`);
      scrollHeightValue = scrollHeightValue + parseFloat(headerHeight);
      var outerheight = parseFloat(headerHeight) + 50;

      if (annoucementHeight) {
        body.style.setProperty('--announcementheight', `${annoucementHeight}px`);
      }

      if (viewportWidth > 991 && transparentEl) {
        body.style.setProperty('--transparentheaderheight', `${headerHeight}px`);
      }

      window.addEventListener('scroll', function () {
        let mainHeader = document.querySelector('header');
        let stickyHeader = mainHeader.getAttribute('data-sticky-header');

        if (stickyHeader == 'false') {
          return false;
        }

        if (stickyHeader == 'true') {
          if (window.scrollY > 50) {
            headerElement.classList.add('stickytrue');
          } else {
            headerElement.classList.remove('stickytrue');
          }
          if (stickyHeaderType == 'on_scroll') {
            if (mainHeader && stickyHeader == 'true') {
              if (window.scrollY > 50) {
                if (windowScroll > window.scrollY) {
                  headerElement.classList.remove('sticky-header-hidden');
                } else {
                  if (!document.querySelector('body').classList.contains('menuopen')) {
                    headerElement.classList.add('sticky-header-hidden');
                  }
                }
              } else {
                headerElement.classList.remove('sticky-header-hidden');
              }
            }
          }
        }
        windowScroll = window.scrollY;
      });

      // Optimized resize handler with debouncing and requestAnimationFrame
      window.addEventListener('resize', function () {
        // Clear any pending resize operations
        if (headerResizeTimer) {
          cancelAnimationFrame(headerResizeTimer);
        }

        // Debounce: wait 150ms after resize stops, then use rAF for smooth execution
        clearTimeout(window.headerResizeDebounce);
        window.headerResizeDebounce = setTimeout(function () {
          headerResizeTimer = requestAnimationFrame(function () {
            // BATCH READS
            const headerMainElResize = headerElement.querySelector('[data-header-main]');
            const transparentElResize = headerElement.querySelector('.transparent-true');
            const bodyResize = document.querySelector('body');
            const viewportWidthResize = window.innerWidth;

            if (!headerMainElResize) return;

            const newHeaderHeight = headerMainElResize.getBoundingClientRect().height.toFixed(2);

            // BATCH WRITES
            bodyResize.style.setProperty('--headerheight', `${newHeaderHeight}px`);

            if (viewportWidthResize > 991 && transparentElResize) {
              bodyResize.style.setProperty('--transparentheaderheight', `${newHeaderHeight}px`);
            }
          });
        }, 150);
      });
    }
  }
}

/* hamburger nemu for mobile header */
function mobileHumburgerMenuInit() {
  let mobileHumburgerElements = document.querySelectorAll('[data-hamburger-mobile]');
  let headerMainParent = document.querySelector('header');
  let body = document.querySelector('body');

  Array.from(mobileHumburgerElements).forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      let drawerElement = element.getAttribute("href");
      let contentDrawerContainer = document.querySelector(drawerElement);
      if (element.classList.contains('active')) {
        if (body.classList.contains('mobile-menu-active')) {
          body.classList.remove('no-scroll', 'mobile-menu-active');
          contentDrawerContainer.classList.remove('active');
          element.classList.remove('active');
        }
      } else {
        element.classList.add('active');
        body.classList.add('no-scroll', 'mobile-menu-active');
        contentDrawerContainer.classList.add('active');
      }
    });

  })
  window.addEventListener("resize", function () {
    if (window.innerWidth > 991 && body.classList.contains('mobile-menu-active')) {
      body.classList.remove('mobile-menu-active', 'no-scroll');
      contentDrawerContainer.classList.remove('show');
    }
  })
}
function mobileMenuitemsEvent() {

  let mobileMenus = document.querySelectorAll(".mobile-menus-item");
  Array.from(mobileMenus).forEach(function (mobileMenu) {
    mobileMenu.addEventListener("click", function (event) {
      if (mobileMenu) {
        mobileMenu.closest("[data-child-items]").classList.add("active")
      }

    })
  })
  let backToNavElemets = document.querySelectorAll("[data-backtonav-items],[data-subbacktonav-items]");
  Array.from(backToNavElemets).forEach(function (navBarbackElement) {
    navBarbackElement.addEventListener("click", function (event) {
      if (event.target.closest('details').hasAttribute("open")) {
        event.target.closest('details[open]').removeAttribute("open");
        event.target.closest('[data-child-items].active').classList.remove("active");
        //mobileMenuitemsEvent();
      }
    })
  })

}

document.addEventListener('DOMContentLoaded', function (section = document) {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
});

document.addEventListener('shopify:section:load', function (section) {
  let sectiontargetHead = section.target;
  stickyheaderLoadInit(sectiontargetHead);
  mobileHumburgerMenuInit(sectiontargetHead);
  mobileMenuitemsEvent(sectiontargetHead);
});
